export const slugToString = (str) => {
  if (!str) return '';
  return str.replace(/-/g, ' ').replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
};
